import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { RequestsProvider } from '../components/Requests/providers/requests.provider';
import { RequestsScreen } from '../screens/requests';

const RequestsRouter: FC = () => (
    <Routes>
        <Route
            path="/"
            element={(
                <RequestsProvider>
                    <RequestsScreen />
                </RequestsProvider>
            )}
        />
    </Routes>
);

export { RequestsRouter };
